import React, { type FC } from 'react';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import MatchRow from './components/MatchRow';
import MatchRowWS from './components/MatchRowWS';

import styles from './MatchTable.module.scss';

type MatchTableProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  // TODO: write types, if you have some free time please :)
  // breadcrumbs: PropTypes.array,
  // tournamentId: PropTypes.number,
  // showGridColumns: PropTypes.bool,
  // subheaderComponent: PropTypes.func,
  // subheaderClassName: PropTypes.string,
  // sportId: PropTypes.number.isRequired,
  // matchIds: PropTypes.object.isRequired,
  matchIds?: Set<number>;
};

const MatchTable: FC<MatchTableProps> = ({
  sportId,
  matchIds,
  breadcrumbs,
  tournamentId,
  subheaderComponent,
  subheaderClassName,
  showGridColumns,
}) => {
  const Header = subheaderComponent;
  const { pathname } = useLocation();
  const isPrematch = pathname.startsWith(ROUTE_PATH.PREMATCH);
  const isPrematchWS = useFeatureFlag(FeatureFlag.PREMATCH_WS);

  return (
    <>
      {subheaderComponent && (
        <Header breadcrumbs={breadcrumbs}
                tournamentId={tournamentId}
                sportId={sportId}
                className={subheaderClassName}
                showGridColumns={showGridColumns} />
      )}

      <div className={styles.matchList}>
        {matchIds && [...matchIds].map((matchId: number) => (isPrematch && isPrematchWS) ? (
          <MatchRowWS key={`match-${matchId}`}
                      matchId={matchId} />
        ) : (
          <MatchRow key={`match-${matchId}`}
                    matchId={matchId} />
        ))}
      </div>
    </>
  );
};

export default MatchTable;
